import { token } from '@atlaskit/tokens';

// Override AK Button styles in order to align them with other TableHeaders on Global repository page
export const SortButtonTheme = (currentTheme: any, themeProps: any) => {
  const { buttonStyles, ...rest } = currentTheme(themeProps);
  return {
    buttonStyles: {
      ...buttonStyles,
      color: `${token('color.text.subtlest')};`,
      fontWeight: token('font.weight.bold'),
    },
    ...rest,
  };
};
